import {
  costLinesService,
  useCostLinesStore,
  useReasonsOfRejection,
} from "entities/CostLines";
import { useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";
import { ROLES, reactSelectStyles } from "shared/config";
import { Button } from "shared/ui";

function ReasonOfCostLineRejection({
  setShowReasonOfCostLineRejection,
  rejection,
  costLineId,
  userRole,
}) {
  const { t } = useTranslation(["CostLine", "Shared"]);

  const [displayReasonsSelect] = useState(userRole === ROLES.ACCOUNTS_PAYABLE);

  const [isRejecting, setIsRejecting] = useState(false);
  const updateCostLineById = useCostLinesStore(
    (state) => state.updateCostLineById
  );
  const [validated, setValidated] = useState(false);

  const { data: reasonsOfRejection, isLoading } = useReasonsOfRejection({
    triggerRequest: userRole === ROLES.ACCOUNTS_PAYABLE,
  });
  const [isSelectInvalid, setIsSelectInvalid] = useState(false);
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [rejectionComment, setRejectionComment] = useState(() =>
    // lack of comment is returned as a string "null" ¯\_(ツ)_/¯
    rejection?.comment === "null" ? "" : rejection?.comment
  );

  const handleRejectionCommentChange = (e) => {
    setRejectionComment(e.target.value);
  };
  const handleReasonsSelect = (values) => {
    setSelectedReasons(values);
    setIsSelectInvalid(false);
  };
  const handleCancel = () => {
    setShowReasonOfCostLineRejection(false);
  };

  const handleReject = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const selectInvalid = displayReasonsSelect && selectedReasons.length === 0;
    setValidated(true);
    setIsSelectInvalid(selectInvalid);
    if (form.checkValidity() === false || selectInvalid) return;
    setIsRejecting(true);
    costLinesService
      .rejectCostLine({
        cost_line_id: costLineId,
        user_role: userRole,
        rejection_reasons: selectedReasons.map((reason) => reason.label),
        comment: rejectionComment,
      })
      .then((updatedCostLine) => {
        updateCostLineById(updatedCostLine.id, updatedCostLine);
        setShowReasonOfCostLineRejection(false);
      })
      .finally(() => {
        setIsRejecting(false);
      });
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleReject}>
      <div>
        {displayReasonsSelect && (
          <Form.Group controlId="validationCustom01">
            <ReactSelect
              styles={reactSelectStyles}
              isMulti
              required
              name="reasons-of-rejection"
              className={isSelectInvalid ? "is-invalid border-error" : ""}
              options={reasonsOfRejection}
              value={selectedReasons}
              onChange={handleReasonsSelect}
              isLoading={isLoading}
            />
            <Form.Control.Feedback type="invalid">
              {t("required", { ns: "Shared" })}
            </Form.Control.Feedback>
          </Form.Group>
        )}

        <Form.Group className="mt-2">
          <Form.Label>{t("labels.provide_rejection_reason")}</Form.Label>
          <Form.Control
            as="textarea"
            type="text"
            required
            placeholder={t("labels.rejection_reason")}
            value={rejectionComment}
            onChange={handleRejectionCommentChange}
          />
          <Form.Control.Feedback type="invalid">
            {t("required", { ns: "Shared" })}
          </Form.Control.Feedback>
        </Form.Group>
      </div>

      <div className="d-flex justify-content-end mt-3 gap-2">
        <Button variant="outline-primary" onClick={handleCancel}>
          {t("buttons.cancel")}
        </Button>
        <Button isLoading={isRejecting} disabled={isRejecting} type="submit">
          {t("buttons.save")}
        </Button>
      </div>
    </Form>
  );
}

export default ReasonOfCostLineRejection;
